import { defineStore } from "pinia";
import salesCardIcon from "@/assets/images/layout/sales-card-icon.svg";
import monthlySalesIcon from "@/assets/images/layout/monthly-sales.svg";
import supplierSales from "@/assets/images/layout/supplier-sales.svg";
import downGrade from "@/assets/images/layout/down-grade.svg";
import upGrade from "@/assets/images/layout/up-grade.svg";
import inTransitIcon from "@/assets/images/layout/in-transit-icon.svg";
import bookMarkIcon from "@/assets/images/layout/book-mark-icon.svg";
import layersIcon from "@/assets/images/layout/layers.svg";
import apiClient from "@/core/buildRequest";

const num = (v) => Number(v) || 0;
const pct = (part, total) =>
  total > 0 ? ((part / total) * 100).toFixed(2) : "0.00";

export const useSalesStore = defineStore("sales", {
  state: () => ({
    tabs: [
      {
        value: "1",
        title: "Allurion Tech",
      },
      {
        value: "4",
        title: "BARIATRIC SOLUT",
      },
      {
        value: "3",
        title: "Victor Medical",
      },
      {
        value: "2",
        title: "CM ENDO NORMAL",
      },
    ],
    activeTab: "1",
    salesData: [
      {
        id: 1,
        key: "total_sales_value",
        title: "Total Sales Value",
        icon: salesCardIcon,
        bgColor: "#eff4ff",
        alt: "sales icon",
        value: "0",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
      {
        id: 2,
        key: "month_sales_value",
        title:
          new Date().toLocaleString("default", { month: "long" }) +
          " Sales Value",
        icon: monthlySalesIcon,
        bgColor: "#FFF4F0",
        alt: "monthly sales icon",
        value: "0",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
      {
        id: 3,
        key: "supplier_sales_value",
        title: "Supplier Sales Value",
        icon: supplierSales,
        bgColor: "#EFEFFF99",
        alt: "supplier sales icon",
        value: "0",
        percentage: "-2.1%",
        iconPercentage: downGrade,
        iconSarStatus: true,
      },
    ],
    tableRowsAllurionTech: [
      {
        id: 1,
        from_date: "2025-01-01",
        to_date: "2025-01-31",
        total_value: 0,
        link: "Allurion Tech",
        name: "Allurion Tech",
      },
    ],
    AllurionTechcards: [
      {
        id: 1,
        key: "total_sales_goods",
        title: "Total Sales Goods",
        icon: salesCardIcon,
        bgColor: "#eff4ff",
        alt: "sales icon",
        value: "156,890",
        percentage: "+12.5%",
        iconPercentage: upGrade,
      },
      {
        id: 2,
        key: "month_sales_value",
        title:
          new Date().toLocaleString("default", { month: "long" }) +
          " Sales Value",
        icon: monthlySalesIcon,
        bgColor: "#FFF4F0",
        alt: "sales icon",
        value: "170,890",
        percentage: "-2.1%",
        iconPercentage: downGrade,
        iconSarStatus: true,
      },
      {
        id: 3,
        key: "supplier_sales_value",
        title: "Supplier Sales Value",
        icon: supplierSales,
        bgColor: "#EFEFFF99",
        alt: "sales icon",
        value: "156,890",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
    ],
    tableRowsBariatricSoult: [
      {
        id: 4,
        from_date: "2025-01-01",
        to_date: "2025-01-31",
        total_value: 0,
        link: "BARIATRIC SOLUT",
        name: "BARIATRIC SOLUT",
      },
    ],
    tableRowVictorMedical: [
      {
        id: 3,
        from_date: "2025-01-01",
        to_date: "2025-01-31",
        total_value: 80230,
        link: "VICTOR MEDICAL",
        name: "Victor Medical",
      },
    ],
    tableRowCMEndoNormal: [
      {
        id: 2,
        from_date: "2025-01-01",
        to_date: "2025-01-31",
        total_value: 0,
        link: "CM ENDO NORMAL",
        name: "CM ENDO NORMAL",
      },
    ],
    salesIitems: [],
    baseColumns: [],
    extraColumns: [],
    visibleExtraColumns: [],

    stockData: [
      {
        id: 1,
        title: "Total Stock Value",
        icon: salesCardIcon,
        bgColor: "#EFF4FF",
        alt: "sales icon",
        value: null,
        percentage: "+12.5%",
        iconPercentage: upGrade,
        key: "total_stock_value",
        iconSarStatus: true,
      },
      {
        id: 2,
        title: "In-transit QTY",
        icon: inTransitIcon,
        bgColor: "#10B98114",
        alt: "in-transit icon",
        value: null,
        percentage: "+12.5%",
        iconPercentage: upGrade,
        key: "in_transit_value",
      },
      {
        id: 3,
        title: "Reserved QTY",
        icon: bookMarkIcon,
        bgColor: "#EFEFFF99",
        alt: "supplier sales icon",
        value: null,
        percentage: "+12%",
        iconPercentage: upGrade,
        key: "reserved_value",
      },
    ],
    stockAllurionTechcards: [
      {
        id: 1,
        date: "",
        stock_value: 0,
        link: "",
        name: "",
      },
    ],
    tableStockRowsBariatricSoult: [
      {
        id: 4,
        date: "",
        stock_value: 0,
        link: "",
        name: "",
      },
    ],
    tableStockRowVictorMedical: [
      {
        id: 3,
        date: "",
        stock_value: 0,
        link: "",
        name: "",
      },
    ],
    tableStockRowCMEndoNormal: [
      {
        id: 2,
        date: "",
        stock_value: 0,
        link: "",
        name: "",
      },
    ],
    stockDetailsPageCards: [
      {
        id: 1,
        title: "Supplier Stock Value",
        icon: monthlySalesIcon,
        bgColor: "#FFF4F0",
        alt: "sales icon",
        value: "156,890",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        key: "supplier_stock_value",
        iconSarStatus: true,
      },
      {
        id: 2,
        title: "Supplier Stock QTY",
        icon: layersIcon,
        bgColor: "#FFF4F0",
        alt: "sales icon",
        value: "467,750",
        percentage: "-2.1%",
        iconPercentage: downGrade,
        key: "supplier_stock_qty",
      },
      {
        id: 3,
        title: "In-transit QTY",
        icon: inTransitIcon,
        bgColor: "#10B98114",
        alt: "sales icon",
        value: "156,890",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        key: "in_transit_value",
      },
      {
        id: 4,
        title: "Reserved QTY",
        icon: bookMarkIcon,
        bgColor: "#EFEFFF99",
        alt: "book mark icon",
        value: "180,890",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        key: "reserved_qty",
      },
    ],
    aging_risk_vendor: {
      aging_risk_value: "",
      aging_risk_percentage: "",
    },
    aging_value_vendor: {
      aging_value: "",
      aging_value_percentage: "",
    },
    expiry_risk_vendor: {
      expiry_risk_value: "",
      expiry_risk_value_percentage: "",
    },
    backOrderCards: [
      {
        id: 1,
        title: "Total BO Value",
        icon: salesCardIcon,
        bgColor: "rgba(239, 244, 255, 1)",
        alt: "sales icon",
        value: "0",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
      {
        id: 2,
        title: "Supplier BO Value",
        icon: supplierSales,
        bgColor: "rgba(239, 239, 255, 0.6)",
        alt: "sales icon",
        value: "0",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
    ],
    backOrderRowsAllurionTech: [
      {
        id: 1,
        date: "2025-01-01",
        total_value: 0,
        link: "Allurion Tech",
        name: "Allurion Tech",
      },
    ],
    backOrderRowsBariatricSoult: [
      {
        id: 4,
        date: "2025-01-01",
        total_value: 0,
        link: "BARIATRIC SOLUT",
        name: "BARIATRIC SOLUT",
      },
    ],
    backOrderRowsVictorMedical: [
      {
        id: 3,
        date: "2025-01-01",
        total_value: 0,
        link: "Victor Medical",
        name: "Victor Medical",
      },
    ],
    backOrderRowsCMEndoNormal: [
      {
        id: 2,
        date: "2025-01-01",
        total_value: 0,
        link: "CM ENDO NORMAL",
        name: "CM ENDO NORMAL",
      },
    ],
    baseColumnsBackOrder: [
      { title: "Vendor #", key: "vendor", filterable: true },
      { title: "SubCate", key: "subCategory", filterable: true },
      { title: "Order No", key: "orderNo", filterable: true },
      { title: "Item #", key: "itemNo", filterable: true },
      { title: "Item Catalog", key: "itemCatalog", filterable: true },
      { title: "Item Name", key: "itemName", filterable: true },
      { title: "B Qty", key: "bQty", filterable: true },
      {
        title: "Line Amount",
        key: "lineAmount",
        filterable: true,
      },
      {
        title: "Req Date",
        key: "reqDate",
        filterable: true,
      },
    ],
    backOrderItems: [
      {
        id: 1,
        vendor: "10023",
        subCategory: "Jan 15, 2025",
        orderNo: "4928",
        itemNo: "12,450",
        itemCatalog: "CAT-2025-B",
        itemName: "CAT-2025-A",
        bQty: "Surgical Stapler",
        lineAmount: "D-7592",
        reqDate: "Dec 01, 2024",
      },
      {
        id: 2,
        vendor: "10045",
        subCategory: "Jan 15, 2025",
        orderNo: "8573",
        itemNo: "12,450",
        itemCatalog: "CAT-2025-C",
        itemName: "CAT-2025-A",
        bQty: "Defibrillator",
        lineAmount: "G-2356",
        reqDate: "Jan 02, 2025",
      },
      {
        id: 3,
        vendor: "10023",
        subCategory: "Jan 15, 2025",
        orderNo: "9584",
        itemNo: "12,450",
        itemCatalog: "CAT-2025-D",
        itemName: "CAT-2025-A",
        bQty: "Endoscope",
        lineAmount: "T-4758",
        reqDate: "Feb 14, 2025",
      },
      {
        id: 4,
        vendor: "10027",
        subCategory: "Jan 15, 2025",
        orderNo: "1058",
        itemNo: "12,450",
        itemCatalog: "CAT-2025-E",
        itemName: "CAT-2025-A",
        bQty: "Ventilator",
        lineAmount: "V-2957",
        reqDate: "Mar 22, 2025",
      },
      {
        id: 5,
        vendor: "10023",
        subCategory: "Jan 15, 2025",
        orderNo: "2957",
        itemNo: "12,450",
        itemCatalog: "CAT-2025-F",
        itemName: "CAT-2025-A",
        bQty: "Ultrasound Machine",
        lineAmount: "Y-6391",
        reqDate: "Apr 02, 2025",
      },
      {
        id: 6,
        vendor: "10045",
        subCategory: "Jan 15, 2025",
        orderNo: "8573",
        itemNo: "12,450",
        itemCatalog: "CAT-2025-C",
        itemName: "CAT-2025-A",
        bQty: "Defibrillator",
        lineAmount: "G-2356",
        reqDate: "Jan 02, 2025",
      },
    ],
    backOrderAllurionTechcards: [
      {
        id: 1,
        title: "Total BO Value",
        icon: salesCardIcon,
        bgColor: "#eff4ff",
        alt: "sales icon",
        value: "0",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
      {
        id: 2,
        title: "Supplier BO Value",
        icon: monthlySalesIcon,
        bgColor: "#FFF4F0",
        alt: "sales icon",
        value: "0",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
      {
        id: 3,
        title: "Supplier BO Qty",
        icon: layersIcon,
        bgColor: "#EFEFFF99",
        alt: "sales icon",
        value: "0",
        percentage: "-2.1%",
        iconPercentage: downGrade,
      },
    ],
    slobCards: [
      {
        id: 1,
        title: "Total SMI Value",
        icon: salesCardIcon,
        bgColor: "rgba(239, 244, 255, 1)",
        alt: "sales icon",
        value: "1,256,890",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
      {
        id: 2,
        title: "Supplier SMI Value",
        icon: inTransitIcon,
        bgColor: "rgba(16, 185, 129, 0.08)",
        alt: "sales icon",
        value: "180,890",
        percentage: "+12.5%",
        iconPercentage: upGrade,
        iconSarStatus: true,
      },
      {
        id: 3,
        title: "Total SMI Qty",
        icon: bookMarkIcon,
        bgColor: "rgba(239, 239, 255, 0.6)",
        alt: "sales icon",
        value: "467,750",
        percentage: "+12.5%",
        iconPercentage: upGrade,
      },
    ],
    baseColumnsSLOB: [],
    slobItems: [],
    slobPagination: {},
    baseColumnsConsigment: [
      { title: "Vendor Site", key: "vendorSite", filterable: true },
      { title: "WHSE", key: "whse", filterable: true },
      { title: "Subinv", key: "subinv", filterable: true },
      { title: "Subinv Name", key: "subinvName", filterable: true },
      { title: "Item Catalogue", key: "itemCatalogue", filterable: true },
      { title: "Item Code", key: "itemCode", filterable: true },
      { title: "Item Desc", key: "itemDesc", filterable: true },
      { title: "Expiry", key: "expiry", filterable: true },
      { title: "Intransit Qty", key: "intransitQty", filterable: true },
      { title: "Reserved Qty", key: "reservedQty", filterable: true },
      { title: "Onhand Qty", key: "onhandQty", filterable: true },
      {
        title: "Cost",
        key: "cost",
        filterable: true,
      },
      { title: "Value", key: "value", filterable: true },
      { title: "Aging", key: "aging", filterable: true },

      {
        title: "Status",
        key: "status",
        filterable: true,
      },
    ],
    consigmentItems: [
      {
        id: 1,
        vendorSite: "10023",
        whse: "MJO",
        subinv: "4928",
        subinvName: "12,450",
        itemCatalogue: "CAT-2025-B",
        itemCode: "76589",
        itemDesc: "Advanced Formula...",
        expiry: "Dec 01, 2024",
        intransitQty: "D-7592",
        reservedQty: "Dec 01, 2024",
        onhandQty: "12,840",
        cost: "4,350",
        value: "88,745",
        aging: "13",
        status: "Normal",
      },
      {
        id: 2,
        vendorSite: "10024",
        whse: "MJO",
        subinv: "4928",
        subinvName: "11,980",
        itemCatalogue: "CAT-2025-C",
        itemCode: "76590",
        itemDesc: "Advanced Formula...",
        expiry: "Nov 15, 2024",
        intransitQty: "D-7592",
        reservedQty: "11,200",
        onhandQty: "10,420",
        cost: "4,120",
        value: "82,300",
        aging: "22",
        status: "Risk",
      },
      {
        id: 3,
        vendorSite: "10025",
        whse: "CAI",
        subinv: "4821",
        subinvName: "13,560",
        itemCatalogue: "CAT-2025-D",
        itemCode: "76591",
        itemDesc: "High Potency Capsule...",
        expiry: "Jan 21, 2025",
        intransitQty: "D-6210",
        reservedQty: "12,450",
        onhandQty: "13,110",
        cost: "5,120",
        value: "92,880",
        aging: "8",
        status: "Slow",
      },
      {
        id: 4,
        vendorSite: "10028",
        whse: "CAI",
        subinv: "4821",
        subinvName: "9,820",
        itemCatalogue: "CAT-2025-E",
        itemCode: "76592",
        itemDesc: "Vitamin Booster...",
        expiry: "Oct 10, 2024",
        intransitQty: "D-5100",
        reservedQty: "8,200",
        onhandQty: "9,100",
        cost: "3,900",
        value: "75,400",
        aging: "33",
        status: "Aging",
      },
      {
        id: 5,
        vendorSite: "10029",
        whse: "ALX",
        subinv: "5501",
        subinvName: "16,200",
        itemCatalogue: "CAT-2025-F",
        itemCode: "76593",
        itemDesc: "Daily Essentials Pack...",
        expiry: "Mar 14, 2025",
        intransitQty: "D-7100",
        reservedQty: "15,000",
        onhandQty: "15,600",
        cost: "6,200",
        value: "110,400",
        aging: "5",
        status: "Normal",
      },
      {
        id: 6,
        vendorSite: "10030",
        whse: "ALX",
        subinv: "5501",
        subinvName: "14,700",
        itemCatalogue: "CAT-2025-G",
        itemCode: "76594",
        itemDesc: "Immune Support Formula...",
        expiry: "Dec 19, 2024",
        intransitQty: "D-6300",
        reservedQty: "13,100",
        onhandQty: "14,100",
        cost: "4,980",
        value: "99,600",
        aging: "18",
        status: "Risk",
      },
      {
        id: 7,
        vendorSite: "10031",
        whse: "MNS",
        subinv: "6022",
        subinvName: "10,450",
        itemCatalogue: "CAT-2025-H",
        itemCode: "76595",
        itemDesc: "Soft Gel Capsules...",
        expiry: "Aug 02, 2024",
        intransitQty: "D-5400",
        reservedQty: "9,700",
        onhandQty: "10,120",
        cost: "3,540",
        value: "63,780",
        aging: "41",
        status: "Aging",
      },
      {
        id: 8,
        vendorSite: "10032",
        whse: "MNS",
        subinv: "6022",
        subinvName: "12,000",
        itemCatalogue: "CAT-2025-I",
        itemCode: "76596",
        itemDesc: "Energy Booster...",
        expiry: "Feb 04, 2025",
        intransitQty: "D-7800",
        reservedQty: "11,200",
        onhandQty: "12,300",
        cost: "5,760",
        value: "113,400",
        aging: "6",
        status: "Slow",
      },
      {
        id: 9,
        vendorSite: "10033",
        whse: "CAI",
        subinv: "4700",
        subinvName: "8,300",
        itemCatalogue: "CAT-2025-J",
        itemCode: "76597",
        itemDesc: "Herbal Mix Powder...",
        expiry: "Sep 27, 2024",
        intransitQty: "D-4900",
        reservedQty: "7,200",
        onhandQty: "7,880",
        cost: "2,980",
        value: "59,710",
        aging: "29",
        status: "Risk",
      },
      {
        id: 10,
        vendorSite: "10034",
        whse: "ALX",
        subinv: "5501",
        subinvName: "15,900",
        itemCatalogue: "CAT-2025-K",
        itemCode: "76598",
        itemDesc: "Omega 3 Ultra...",
        expiry: "Apr 11, 2025",
        intransitQty: "D-8200",
        reservedQty: "14,600",
        onhandQty: "15,320",
        cost: "6,780",
        value: "122,880",
        aging: "4",
        status: "Normal",
      },
    ],
    card_loading: false,
    aging_risk: {
      aging_risk_value: 0,
      aging_risk_percentage: 0,
    },
    aging_value: {
      aging_value: 0,
      aging_value_percentage: 0,
    },
    expiry_risk: {
      expiry_risk_value: 0,
      expiry_risk_value_percentage: 0,
    },
    stockPagination: {
      total_items: 0,
      per_page: 15,
      current_page: 1,
      total_pages: 1,
    },
    salesDetailsPagination: {
      total_items: 0,
      per_page: 15,
      current_page: 1,
      total_pages: 1,
    },
    stockCompareData: [],
    stockComparePagination: {
      total_items: 0,
      per_page: 15,
      current_page: 1,
      total_pages: 1,
    },
    stockCompareSummary: {},
    salesCompareData: [],
    salesCompareSummary: {},
  }),
  actions: {
    formatNumber(num) {
      if (num == null) return null;
      return new Intl.NumberFormat().format(num);
    },
    async getTotalStockData(showLoader = true) {
      try {
        this.card_loading = true;

        const { data } = await apiClient.get("stocks/accounts", {
          showLoader,
        });

        const totals = data.data;

        // Update stockData values
        this.stockData = this.stockData.map((item) => {
          if (totals[item.key] !== undefined) {
            return {
              ...item,
              value: this.formatNumber(totals[item.key]),
            };
          }
          return item;
        });

        const total = Number(totals.total_stock_value) || 0;

        this.aging_risk.aging_risk_value = num(totals.aging_risk_value);
        this.aging_risk.aging_risk_percentage =
          total > 0
            ? num(((totals.aging_risk_value / total) * 100).toFixed(2))
            : 0;

        this.aging_value.aging_value = num(totals.aging_value);
        this.aging_value.aging_value_percentage =
          total > 0 ? num(((totals.aging_value / total) * 100).toFixed(2)) : 0;

        this.expiry_risk.expiry_risk_value = num(totals.expiry_risk_value);
        this.expiry_risk.expiry_risk_value_percentage =
          total > 0
            ? num(((totals.expiry_risk_value / total) * 100).toFixed(2))
            : 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.card_loading = false;
      }
    },
    async getVendorTableData(vendor_id, showLoader = true) {
      try {
        const { data } = await apiClient.get("stocks", {
          params: { vendor_id },
          showLoader,
        });

        const rows = data.data;

        // Map vendor.id to the corresponding store array
        const tablesMap = {
          1: "stockAllurionTechcards",
          4: "tableStockRowsBariatricSoult",
          3: "tableStockRowVictorMedical",
          2: "tableStockRowCMEndoNormal",
        };

        const tableKey = tablesMap[vendor_id];

        if (tableKey && Array.isArray(this[tableKey])) {
          this[tableKey] = rows.map((row) => ({
            ...row,
            link: row.name, // Keep consistency if needed
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    generateColumnsFromData(rows) {
      if (!rows.length) return;

      const allKeys = new Set();
      rows.forEach((row) => {
        Object.keys(row).forEach((k) => allKeys.add(k));
      });

      const keys = Array.from(allKeys);

      // Define default visible columns (keys)
      // Matches screenshot order: Whse, Subinv, Subinv Name, Expiry, Reserved Value, Cost, Value, Aging, Intransit Qty, Reserved Qty, Onhand Qty, Item Catalog, Item Code
      const defaultVisibleKeys = [
        "Whse",
        "Subinv",
        "Subinv Name",
        "Item Catalog",
        "Item Code",
        "Item Desc",
        "Expiry",
        "Onhand Qty",
        "Cost",
        "Value",
        "Intransit Qty",
        "Reserved Qty",
        "Aging",
      ];

      // Base columns: usually locked or very important. User didn't specify any locked columns.
      this.baseColumns = [];

      // Extra columns: ALL columns
      this.extraColumns = keys.map((key) => ({
        title: this.formatColumnTitle(key),
        key,
        filterable: true,
      }));

      // Initialize visible extra columns based on default list and ORDER
      if (
        !Array.isArray(this.visibleExtraColumns) ||
        !this.visibleExtraColumns.length
      ) {
        this.visibleExtraColumns = [];

        const availableKeys = this.extraColumns.map((c) => c.key);

        defaultVisibleKeys.forEach((defKey) => {
          // Try to find a matching key in available keys
          // prioritize exact match then loose match
          const exactMatch = availableKeys.find(
            (k) =>
              k.toLowerCase() === defKey.toLowerCase() ||
              k.toLowerCase() === defKey.replace(/_/g, "").toLowerCase(),
          );
          if (exactMatch) {
            if (!this.visibleExtraColumns.includes(exactMatch)) {
              this.visibleExtraColumns.push(exactMatch);
            }
            return;
          }

          // Loose match
          const looseMatch = availableKeys.find(
            (k) =>
              k.toLowerCase().includes(defKey) ||
              defKey.includes(k.toLowerCase()),
          );
          if (looseMatch && !this.visibleExtraColumns.includes(looseMatch)) {
            // Avoid false positives like "value" matching "reserved_value" if "reserved_value" was already picked?
            // But here "value" is in the list, so we might want to pick "value" specifically.
            // If we already picked "reserved_value" for "reserved_value", we shouldn't pick it again for "value".
            // But "value" might match "value".

            // Let's rely on finding the specific key.
            this.visibleExtraColumns.push(looseMatch);
          }
        });
      } else {
        // Validation for existing selection
        const extraKeys = new Set(this.extraColumns.map((c) => c.key));
        this.visibleExtraColumns = this.visibleExtraColumns.filter((k) =>
          extraKeys.has(k),
        );
      }
    },
    generateSalesColumnsFromData(rows) {
      if (!rows.length) return;

      const allKeys = new Set();
      rows.forEach((row) => {
        Object.keys(row).forEach((k) => allKeys.add(k));
      });

      const keys = Array.from(allKeys);

      // Requested Sales Default Columns
      const defaultVisibleKeys = [
        "branch_name",
        "invoice_date",
        "invoice_number",
        "customer_number",
        "customer_name",
        "customer_nature",
        "item_no",
        "item_description",
        "vndr_catalog",
        "current_sales_goods",
        "current_sales_value",
      ];

      // Base columns: empty
      this.baseColumns = [];

      // Extra columns: ALL columns
      this.extraColumns = keys.map((key) => ({
        title: this.formatColumnTitle(key),
        key,
        filterable: true,
      }));

      // Initialize visible extra columns based on default list
      this.visibleExtraColumns = [];

      const availableKeys = this.extraColumns.map((c) => c.key);

      defaultVisibleKeys.forEach((defKey) => {
        if (availableKeys.includes(defKey)) {
          this.visibleExtraColumns.push(defKey);
        }
      });
    },
    generateBackOrderColumnsFromData(rows) {
      if (!rows.length) return;

      const allKeys = new Set();
      rows.forEach((row) => {
        Object.keys(row).forEach((k) => allKeys.add(k));
      });

      const keys = Array.from(allKeys);

      // Requested Back Order Default Columns
      const defaultVisibleKeys = [
        "order_no",
        "customer",
        "vendor_site",
        "item_no",
        "item_name",
        "item_catalog",
        "b_qty",
        "line_amount",
        "customer_po",
        "req_date",
      ];

      // Base columns: empty
      this.baseColumns = [];

      // Extra columns: ALL columns
      this.extraColumns = keys.map((key) => ({
        title: this.formatColumnTitle(key),
        key,
        filterable: true,
      }));

      // Initialize visible extra columns based on default list
      this.visibleExtraColumns = [];

      const availableKeys = this.extraColumns.map((c) => c.key);

      defaultVisibleKeys.forEach((defKey) => {
        // Try precise match first
        if (availableKeys.includes(defKey)) {
          this.visibleExtraColumns.push(defKey);
        } else {
          // Try loose match (case-insensitive)
          const looseMatch = availableKeys.find(
            (k) => k.toLowerCase() === defKey.toLowerCase(),
          );
          if (looseMatch && !this.visibleExtraColumns.includes(looseMatch)) {
            this.visibleExtraColumns.push(looseMatch);
          }
        }
      });
    },
    formatColumnTitle(key) {
      return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    async getVendorData(vendor_id, page = 1, per_page = 15, filters = null) {
      try {
        const params = { vendor_id, page, per_page };

        if (filters && Array.isArray(filters) && filters.length > 0) {
          filters.forEach((filter, index) => {
            if (filter.column && filter.value) {
              // Special handling for aging to send as flat parameters if desired
              if (filter.column === "aging_operator") {
                params.aging_operator = filter.value;
              } else if (filter.column === "aging_value") {
                params.aging_value = filter.value;
              } else {
                params[`filters[${index}][column]`] = filter.column;
                params[`filters[${index}][value]`] = filter.value;
              }
            }
          });
        }

        const { data } = await apiClient.get(`stocks/${vendor_id}`, {
          params,
        });

        const payload = data?.data ?? {};
        console.log("getVendorData API Response:", data);
        console.log("Extracted payload:", payload);

        const totals = payload.total ?? {};
        const rows = payload.data ?? (Array.isArray(payload) ? payload : []);
        console.log("Extracted rows count:", rows.length);

        this.stockPagination = payload.pagination ?? {};

        // ====== cards/pies ======
        const supplierStockValue = num(totals.supplier_stock_value);
        const agingRiskValue = num(totals.aging_risk_value);
        const agingValue = num(totals.aging_value);
        const expiryRiskValue = num(totals.expiry_risk_value);

        this.aging_risk_vendor.aging_risk_value = agingRiskValue;
        this.aging_risk_vendor.aging_risk_percentage = num(
          pct(agingRiskValue, supplierStockValue),
        );

        this.aging_value_vendor.aging_value = agingValue;
        this.aging_value_vendor.aging_value_percentage = num(
          pct(agingValue, supplierStockValue),
        );

        this.expiry_risk_vendor.expiry_risk_value = expiryRiskValue;
        this.expiry_risk_vendor.expiry_risk_value_percentage = num(
          pct(expiryRiskValue, supplierStockValue),
        );

        this.stockDetailsPageCards = this.stockDetailsPageCards.map((item) => ({
          ...item,
          value: this.formatNumber(num(totals[item.key])),
        }));

        // ====== table items (FINAL shape) ======
        const mappedRows = rows.map((row) => {
          const mapped = { ...row };
          if (row.vendor && typeof row.vendor === "object") {
            mapped.vendor = row.vendor.name || "-";
          }
          return mapped;
        });

        this.salesIitems = mappedRows;

        // ✅ generate columns based on FINAL shape
        this.generateColumnsFromData(mappedRows, 4);
      } catch (error) {
        console.error(error);
      }
    },
    pickTablePayload(payload) {
      // خُد payload كله ماعدا totals
      const { totals, ...table } = payload || {};
      console.log(totals);

      return table;
    },
    normalizeEmpty(val) {
      // اعتبر القيم دي "فاضية" فتتشال أعمدتها
      return val === null || val === undefined || val === "";
    },
    toTitle(key) {
      // title كويس بدل auto ugly
      return key
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, (l) => l.toUpperCase());
    },
    formatDate(dateString) {
      if (!dateString || dateString === "-") return dateString || "-";

      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;

        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];

        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();

        return `${month} ${day}, ${year}`;
      } catch (error) {
        return dateString;
      }
    },
    async getSlobCardsData(
      vendor_id = 1,
      filters = null,
      page = 1,
      per_page = 100,
      showLoader = true,
    ) {
      console.log("🔥 getSlobCardsData called with:", {
        vendor_id,
        filters,
        page,
        per_page,
      });
      try {
        const params = { vendor_id, page, per_page };
        console.log("SLOB API Params:", params);

        // Handle multiple filters
        if (filters && Array.isArray(filters) && filters.length > 0) {
          filters.forEach((filter, index) => {
            if (filter.column && filter.value) {
              params[`filters[${index}][column]`] = filter.column;
              params[`filters[${index}][value]`] = filter.value;
            }
          });
        } else if (
          filters &&
          typeof filters === "object" &&
          filters.column &&
          filters.value
        ) {
          // Handle single filter (backward compatibility)
          params["filters[0][column]"] = filters.column;
          params["filters[0][value]"] = filters.value;
        }

        const { data } = await apiClient.get("slobs", { params, showLoader });
        console.log("SLOB API Response:", data);

        if (data?.key === "success" && data?.data?.totals) {
          const totals = data.data.totals;
          const rows = data.data.data || [];
          const pagination = data.data.pagination || {};
          const num = (v) => Number(v) || 0;

          console.log("SLOB Rows length:", rows.length);
          console.log("SLOB Rows:", rows);
          console.log("SLOB Totals:", totals);
          console.log("SLOB Pagination:", pagination);
          console.log(
            "Expected per_page:",
            100,
            "Actual per_page:",
            pagination.per_page,
          );

          // Store pagination info
          this.slobPagination = pagination;

          // Update slobCards with API values
          this.slobCards = this.slobCards.map((card) => {
            if (card.id === 1) {
              return {
                ...card,
                value: this.formatNumber(num(totals.total_slob_value)),
              };
            }
            if (card.id === 2) {
              return {
                ...card,
                value: this.formatNumber(num(totals.supplier_slob_value)),
              };
            }
            if (card.id === 3) {
              return {
                ...card,
                value: this.formatNumber(totals.total_slob_qty),
              };
            }
            return card;
          });

          // Build dynamic columns from first row data
          if (rows.length > 0) {
            // Flatten nested objects for table display
            const flattenedRows = rows.map((row) => {
              const flattened = { ...row };

              // Remove vendor object completely - don't flatten vendor data
              if (row.vendor && typeof row.vendor === "object") {
                delete flattened.vendor;
              }

              // Format last_invoice_date to "Feb 14, 2025" format
              if (row.last_invoice_date) {
                flattened.last_invoice_date = this.formatDate(
                  row.last_invoice_date,
                );
              }

              return flattened;
            });
            const firstRow = flattenedRows[0];
            const keys = Object.keys(firstRow).filter((k) => k !== "id");

            console.log("Column Keys:", keys);

            const cols = keys.map((key) => ({
              title: this.toTitle(key),
              value: key,
              key,
              filterable: true,
            }));
            // Set dynamic columns
            this.baseColumns = [];
            this.extraColumns = cols;

            // Set visible columns (show all by default)
            this.visibleExtraColumns = this.extraColumns.map((c) => c.key);

            // Set table items with flattened data
            this.slobItems = flattenedRows;

            console.log("Final slobItems:", this.slobItems);
            console.log("Final baseColumns:", this.baseColumns);
            console.log("Final extraColumns:", this.extraColumns);
          } else {
            console.log("No rows found. Clearing SLOB data.");
            this.slobItems = [];
            this.baseColumns = [];
            this.extraColumns = [];
            this.visibleExtraColumns = [];
          }
        }
      } catch (error) {
        console.error("Error fetching SLOB cards data:", error);
      }
    },
    async getBackOrderVendorData(
      vendor_id,
      page = 1,
      per_page = 100,
      filters = null,
      showLoader = true,
    ) {
      try {
        const params = { page, per_page };

        if (filters && Array.isArray(filters) && filters.length > 0) {
          filters.forEach((filter, index) => {
            if (filter.column && filter.value) {
              if (filter.column === "month") {
                params.month = filter.value;
              } else {
                params[`filters[${index}][column]`] = filter.column;
                params[`filters[${index}][value]`] = filter.value;
              }
            }
          });
        }

        const { data } = await apiClient.get(`back-orders/${vendor_id}`, {
          params,
          showLoader,
        });

        // Ultra-robust extraction
        const resData = data || {};
        const payloadData = data.data || {};
        const summary = resData.summary || payloadData.summary || resData;

        const num = (v) => Number(v) || 0;

        // KPI Cards Update
        this.backOrderAllurionTechcards = this.backOrderAllurionTechcards.map(
          (c) => {
            if (c.id === 1)
              return {
                ...c,
                value: this.formatNumber(
                  num(summary.bo_value ?? summary.total_bo_value),
                ),
              };
            if (c.id === 2)
              return {
                ...c,
                value: this.formatNumber(
                  num(
                    summary.supplier_bo_value ??
                      summary.total_supplier_bo_value,
                  ),
                ),
              };
            if (c.id === 3)
              return {
                ...c,
                value: this.formatNumber(
                  num(summary.supplier_bo_qty ?? summary.total_supplier_bo_qty),
                ),
              };
            return c;
          },
        );

        // Robust row extraction: look for table, data, sales or root array
        const rows =
          resData.table ||
          payloadData.table ||
          resData.data ||
          payloadData.sales ||
          (Array.isArray(resData) ? resData : []) ||
          [];

        if (rows.length > 0) {
          const mappedRows = rows.map((row) => {
            const mapped = { ...row };
            if (row.vendor && typeof row.vendor === "object") {
              mapped.vendor = row.vendor.name || "-";
            }
            return mapped;
          });

          this.salesIitems = mappedRows;
          // this.generateColumnsFromData(mappedRows, 4);
          this.generateBackOrderColumnsFromData(mappedRows);

          // Update visible columns (maintain selection if exists)
          if (
            !Array.isArray(this.visibleExtraColumns) ||
            !this.visibleExtraColumns.length
          ) {
            this.visibleExtraColumns = this.extraColumns.map((c) => c.key);
          } else {
            const extraKeys = new Set(this.extraColumns.map((c) => c.key));
            this.visibleExtraColumns = this.visibleExtraColumns.filter((k) =>
              extraKeys.has(k),
            );
          }
        } else {
          this.salesIitems = [];
          this.extraColumns = [];
          this.baseColumns = [];
        }

        // Update pagination
        this.salesDetailsPagination =
          resData.pagination ||
          payloadData.pagination ||
          resData.meta?.pagination ||
          {};

        return resData;
      } catch (error) {
        console.error("Error fetching back orders:", error);
      }
    },
    async getSalesDetailsData(
      vendor_id,
      page = 1,
      per_page = 100,
      filters = null,
      showLoader = true,
      time = null,
    ) {
      try {
        const params = { page, per_page };
        if (time) params.time = time;

        if (filters && Array.isArray(filters) && filters.length > 0) {
          filters.forEach((filter, index) => {
            if (filter.column && filter.value) {
              if (filter.column === "month") {
                params.month = filter.value;
              } else {
                params[`filters[${index}][column]`] = filter.column;
                params[`filters[${index}][value]`] = filter.value;
              }
            }
          });
        }

        const response = await apiClient.get(`sales/${vendor_id}`, {
          params,
          showLoader,
        });

        const resData = response.data || {};
        const dataObj = resData.data || {};
        const summaryObj = resData.summary || dataObj.summary || resData;

        // Ultra-robust exhaustive mapping for cards
        this.AllurionTechcards = this.AllurionTechcards.map((item) => {
          const k = item.key;
          const val =
            resData[k] ??
            summaryObj[k] ??
            dataObj[k] ??
            (typeof dataObj === "object" ? dataObj[k] : 0) ??
            0;

          return {
            ...item,
            value: this.formatNumber(num(val)),
          };
        });

        // Safe table rows extraction
        let rows = [];
        if (Array.isArray(resData.sales)) {
          rows = resData.sales;
        } else if (Array.isArray(dataObj.sales)) {
          rows = dataObj.sales;
        } else if (Array.isArray(resData.data)) {
          rows = resData.data;
        } else if (Array.isArray(resData)) {
          rows = resData;
        }

        this.salesIitems = rows.map((row) => ({
          ...row,
          vendor: row.vendor?.name || row.vendor || "-",
        }));

        // Safe pagination extraction
        this.salesDetailsPagination =
          resData.pagination || dataObj.pagination || {};

        // generate columns
        // generate columns using separate Sales logic
        this.generateSalesColumnsFromData(this.salesIitems);

        return resData;
      } catch (error) {
        console.error("Error fetching sales details:", error);
      }
    },
    async getColumnOptions(module, column, vendor_id, time, date = null, filters = null) {
      try {
        const params = {
          module,
          column,
        };

        if (vendor_id) params.vendor_id = vendor_id;
        if (time) params.time = time;
        if (date) params.date = date;

        if (filters && Array.isArray(filters) && filters.length > 0) {
          filters.forEach((filter, index) => {
            if (filter.column && filter.value) {
              params[`filters[${index}][column]`] = filter.column;
              params[`filters[${index}][value]`] = filter.value;
            }
          });
        }

        const response = await apiClient.get("advanced-search/column-options", {
          params,
          showLoader: false,
        });

        return response.data?.data || [];
      } catch (error) {
        console.error("Error fetching column options:", error);
        return [];
      }
    },
    // ✅ Stock Dynamic Comparison
    async getStockCompareData(vendor_id, page = 1, per_page = 50) {
      try {
        console.log('🔍 API Request:', { vendor_id, page, per_page });
        const { data } = await apiClient.get(`stocks/${vendor_id}/compare`, {
          params: { page, per_page },
        });

        // console.log('📥 API Response:', data);
        // console.log('📊 Data Length:', data?.data?.matched_data?.length);
        // console.log('📊 Pagination:', data?.data?.matched_pagination);

        if (data?.key === "success") {
          const payload = data.data || {};
          this.stockCompareData = payload.matched_data || [];
          this.stockComparePagination = payload.matched_pagination || {};
          this.stockCompareSummary = payload.matched_summary || {};
        }
      } catch (error) {
        console.error("Error fetching stock compare data:", error);
      }
    },

    async getStockCompareNotifyData() {
      try {
        const { data } = await apiClient.post("stocks/compare/notify", {
          showLoader: false,
        });
        return data;
      } catch (error) {
        console.error("Error triggering stock compare notify:", error);
        throw error;
      }
    },

    // ✅ Sales Dynamic Comparison (Today's Global View)
    async getSalesCompareData(page = 1, per_page = 50) {
      try {
        const { data } = await apiClient.get("sales/compare/today", {
          params: { page, per_page },
        });

        if (data?.key === "success") {
          const payload = data.data || {};
          this.salesCompareData = payload.data || [];
          this.salesCompareSummary = {
            ...(payload.summary || {}),
            date_context: payload.date_context || {},
          };
        }
        return data;
      } catch (error) {
        console.error("Error fetching sales compare data:", error);
        throw error;
      }
    },
  },
});
